import React, { createContext, useState, lazy, Suspense } from 'react';
import SuperSet from './Admin-supersetDashboard';
// import AdminSampleCollectionAgents from './Admin-SampleCollectionAgents';
// import AdminLabOrders from './Admin-LabOrders';
// import AddSampleCollectionAgent from './Admin-AddSampleCollectionAgent';
// import Verifications from './Admin-newverifications';
// import NewComplaints from './Admin-newcomplaints';
// import AdminCoupons from './Admin-Coupons';
// import PanlesList from './Admin-PanelsList';
// import CreatePanel from './Admin-CreatePanel';
// import CustomDrugs from './Admin-CustomDrugs';
// import HealthTips from './Admin-Healthtips.js';
// import Wellness from './Admin-Wellness.js';
// import WellnessGoals from './Admin-WellnessGoals.js';
// import AdminUsersList from './Admin-UsersList.js';
// import AdminSubscripions from './Admin-Subscriptions.js';
// import AdminTests from './Admin-Tests.js';
// import AddSingleParameterTest from './Admin-AddSingleParameterTest.js'
// import AdminsList from './Admin-AdminsList.js';
// import SubscriptionPackages from './Admin-SubscriptionPackages.js';
// import AddMultiParameterTest from './Admin-AddMultiParameterTest.js'
// import ChangePassword from './Admin-ChangePassword.js';
// import AdminTransactions from './Admin-Transactions.js';
// import GenerateReports from './AdminGenerateReports.js';
// import ViewReport from './Admin-ViewReport.js'
// // import Overviews from './Admin-IndexedDb.js';
// import AllergiesComponent from './Admin-IndexedDb.js';
// import CreateWellnessProgramme from './Admin-AddWellnessProgramme.js';
// import AdminSpecialitiesList from './Admin-SpecialitiesList.js';

// const Verifications = lazy(() => import('./Admin-newverifications'));
const Verifications = lazy(() => import('./Admin-Verifications-class'));
const NewComplaints = lazy(() => import('./Admin-complaints'));
const AdminCoupons = lazy(() => import('./Admin-Coupons'));
const PanlesList = lazy(() => import('./Admin-PanelsList'));
const CreatePanel = lazy(() => import('./Admin-CreatePanel'));
const CustomDrugs = lazy(() => import('./Admin-CustomDrugs'));
const HealthTips = lazy(() => import('./Admin-Healthtips'));
const Wellness = lazy(() => import('./Admin-Wellness'));
const WellnessGoals = lazy(() => import('./Admin-WellnessGoals'));
const AdminUsersList = lazy(() => import('./Admin-UsersList'));
const AdminSubscripions = lazy(() => import('./Admin-Subscriptions'));
const AdminTests = lazy(() => import('./Admin-Tests'));
const AddSingleParameterTest = lazy(() => import('./Admin-AddSingleParameterTest'));
const AdminsList = lazy(() => import('./Admin-AdminsList'));
const SubscriptionPackages = lazy(() => import('./Admin-SubscriptionPackages'));
const AddMultiParameterTest = lazy(() => import('./Admin-AddMultiParameterTest'));
const ChangePassword = lazy(() => import('./Admin-ChangePassword'));
const AdminTransactions = lazy(() => import('./Admin-Transactions'));
const GenerateReports = lazy(() => import('./AdminGenerateReports'));
const ViewReport = lazy(() => import('./Admin-ViewReport'));
const AllergiesComponent = lazy(() => import('./Admin-IndexedDb'));
const CreateWellnessProgramme = lazy(() => import('./Admin-AddWellnessProgramme'));
const AdminSpecialitiesList = lazy(() => import('./Admin-SpecialitiesList'));
const AdminFaq = lazy(() => import('./Admin-FAQ'));
const ReferenceTestsVerification = lazy(() => import('./ReferenceTestsVerification'));
const TestComments = lazy(() => import('./testcomments'));
const AdminSampleCollectionAgents = lazy(() => import('./Admin-SampleCollectionAgents'));
const AdminLabOrders = lazy(() => import('./Admin-LabOrders'));
const AddSampleCollectionAgent = lazy(() => import('./Admin-AddSampleCollectionAgent'));
const Promotions = lazy(() => import('./Admin-Promotions'));
const Analytics = lazy(() => import('../Analytics/clinicAnalytics'));
const SupersetChart = lazy(() => import('./Admin-superset-charts'));
const LabExecutiveTests = lazy(() => import('./Admin-LabExecutiveTests'));
// const WellnessProgrammeConfig = lazy(() => import('./Admin-WellnessProgrammeConfig'));

export const EditDataContext = createContext();
export const WellnessContext = createContext();


function AdminMainContent({ selectedComponent, handleComponentSelect }) {
    let componentToRender;
    const [editData, setProgramDataPassing] = useState('');
    const [sharedState, setSharedState] = useState("");
    const [wellnessState, setWellnessState] = useState("");
    const [commentsState, setCommentsState] = useState("");
    console.log("reportsconsole", selectedComponent,);
    // if (!selectedComponent) {
    //     selectedComponent = sessionStorage.getItem("activeLink")
    // }
    // console.log("selectedComponent", selectedComponent, sessionStorage.getItem("token"), wellnessState,editData);
    switch (selectedComponent) {
        case 'Verifications':
        case null:
            componentToRender = <Verifications />;
            break;
        case 'Complaints':
            componentToRender = <NewComplaints />;
            break;
        case 'Coupons':
            componentToRender = <AdminCoupons />;
            break;
        case 'Panels':
            componentToRender = <PanlesList handleComponentSelect={handleComponentSelect} setProgramDataPassing={setProgramDataPassing} />;
            break;
        case 'AddNewPanel':
            componentToRender = <CreatePanel handleComponentSelect={handleComponentSelect} />;
            break;
        case 'CustomDrugs':
            componentToRender = <CustomDrugs />;
            break;
        case 'Healthtips':
            componentToRender = <HealthTips />;
            break;
        case 'Wellness':
            componentToRender = (
                <WellnessContext.Provider value={wellnessState}>
                    <Wellness handleComponentSelect={handleComponentSelect} setWellnessState={setWellnessState} />
                </WellnessContext.Provider>
            );
            break;
        case 'CreateWellnessProgramme':
            // componentToRender = <CreateWellnessProgramme handleComponentSelect={handleComponentSelect} />;
            componentToRender = (
                <WellnessContext.Provider value={wellnessState}>
                    <CreateWellnessProgramme handleComponentSelect={handleComponentSelect} />
                </WellnessContext.Provider>
            );
            break;
        case 'WellnessGoals':
            componentToRender = <WellnessGoals />;
            break;
        case 'Users':
            componentToRender = <AdminUsersList />;
            break;
        case 'Subscriptions':
            componentToRender = <AdminSubscripions />;
            break;
        case 'Tests':
            componentToRender = <AdminTests handleComponentSelect={handleComponentSelect} state={sharedState} setState={setSharedState} />;
            break;
        case 'AddSingleParameterTest':
            componentToRender = <AddSingleParameterTest
                handleComponentSelect={handleComponentSelect}
                state={sharedState} setCommentsState={setCommentsState}
            />;
            break;
        case 'AddMultiParameterTest':
            componentToRender = <AddMultiParameterTest
                handleComponentSelect={handleComponentSelect}
                state={sharedState} setCommentsState={setCommentsState}
            />;
            break;
        case 'TestComments':
            componentToRender = <TestComments
                handleComponentSelect={handleComponentSelect}
                setComments={commentsState}
            />
            break;
        case 'Admins':
            componentToRender = <AdminsList />;
            break;
        case 'SubscriptionPackages':
            componentToRender = <SubscriptionPackages />;
            break;
        case 'referenceTestsVerification':
            componentToRender = <ReferenceTestsVerification handleComponentSelect={handleComponentSelect} state={sharedState} setState={setSharedState} />;
            break;
        case 'ChangePassword':
            componentToRender = <ChangePassword />;
            break;
        case 'Transactions':
            componentToRender = <AdminTransactions />;
            break;
        case 'Faq':
            componentToRender = <AdminFaq />;
            break;
        case 'GenerateReports':
            componentToRender = <GenerateReports handleComponentSelect={handleComponentSelect} />;
            break;
        case 'ViewReport':
            componentToRender = <ViewReport />;
            break;
        case 'IndexedDB':
            componentToRender = <AllergiesComponent />;
            break;

        case 'SpecialitiesList':
            componentToRender = <AdminSpecialitiesList />;
            break
        case "SampleCollectionAgents":
            componentToRender = <AdminSampleCollectionAgents handleComponentSelect={handleComponentSelect} />;
            break
        case "LabOrders":
            componentToRender = <AdminLabOrders handleComponentSelect={handleComponentSelect} />;
            break
        case "Promotions":
            componentToRender = <Promotions />;
            break
        case "AddAgent":
            componentToRender = <AddSampleCollectionAgent handleComponentSelect={handleComponentSelect} />
            break
        case "analytics":
            componentToRender = <SuperSet />;
            // componentToRender = <SupersetChart />;
            break
        case "analytics-reports":
            componentToRender = <Analytics />;
            // componentToRender = <SupersetChart />;
            break
        case "LabExecutiveTests":
            componentToRender = <LabExecutiveTests handleComponentSelect={handleComponentSelect} state={sharedState} setState={setSharedState} />;
            break
        // case "WellnessProgrammeConfig":
        //     componentToRender = <WellnessProgrammeConfig handleComponentSelect={handleComponentSelect} state={sharedState} setState={setSharedState} />;
        //     break
        default:
            componentToRender = null;
    }

    return (
        // <EditDataContext.Provider value={editData}>
        //     <div className="row" style={{ paddingInline: '0px' }}>
        //         {componentToRender}
        //     </div>
        // </EditDataContext.Provider>

        <EditDataContext.Provider value={editData}>
            <Suspense fallback={<div>Loading...</div>}>
                <div className="row h-full" style={{ paddingInline: '0px' }}>
                    {componentToRender}
                </div>
            </Suspense>
        </EditDataContext.Provider>


    );
}


export default AdminMainContent;